import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Card } from '@tekman/shared/models';

@Component({
  selector: 'tekman-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements AfterViewInit {
  @Input() card: Card;
  @Input() disabled = false;
  @Input() empty = false;
  @Input() style: string;
  @Output() emitClick: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('cardDOM') cardDOM: ElementRef<any>;

  ngAfterViewInit(): void {
    if (this.style) {
      this.cardDOM['nativeElement'].classList.add(this.style);
    }
  }
}
